<template>
  <div class="organ-location-auto ubv" style="padding: 0 16px; height: 100%">
    <div class="search-hd">
      <div class="tip">
        <i class="icon icon-tishi"></i>
        <span>{{$t('base_organ_location_auto.bmkglckjrdkwbmsgtjjq')}}</span>
      </div>
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item>
          <el-button type="primary" icon="el-icon-plus" v-if="funcView.depuser_dep_add_location" :disabled="!organ.bizId" @click="onBind">{{ $t('Common.com_added') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-minus" v-if="funcView.depuser_dep_remove_location" :disabled="!tableSelect.length" @click="onUnbind">{{ $t('base_organ_location_auto.yi_chu') }}</el-button>
        </el-form-item>
        <!-- 配置表格列 -->
        <el-form-item style="float: right; margin-right: 0">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <!-- 搜索栏 -->
        <el-form-item style="float: right">
          <search-input :placeholder="$t('base_organ_location_auto.ssgsxmmc')" v-model="formSearch.search" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-bd">
      <custom-table
        height="100%"
        type="checkbox"
        v-model="tableSelect"
        tableCode="organ_location_item"
        :filterArr="['departmentName']"
        :data="tableList"
        @column="setColumn"
        @filter="filterChange"
        @sort="sortChange"
      ></custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <select-location-dialog v-if="dialogVisible" :model="dialogModel" :organ="organ" @close="dialogVisible = false" @success="onSuccess"></select-location-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import selectLocationDialog from './select_location_dialog.vue';

export default {
  components: { selectLocationDialog },
  props: {
    organ: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      tableSelect: [],
      formSearch: {
        search: '',
        bizId: '',
        bizType: '',
        parentId: '',
        isAss: 1,
        pageSize: 10,
        pageNum: 1,
      },
      tableList: [],
      totalRows: 0,
      dialogVisible: false,
      dialogModel: {},
    };
  },
  watch: {
    organ: function () {
      this.formSearch = JSON.parse(this.resetFormSearch);
      this.tableList = [];
      this.totalRows = 0;
      this.getLocationPage();
    },
  },
  mounted: function () {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getFuncView('/company/organdevice');
    this.getLocationPage();
  },
  methods: {
    onSuccess() {
      this.$emit('success');
      this.getLocationPage();
    },
    // 组织关联的项目
    getLocationPage: function () {
      if (!this.organ.bizId) {
        return;
      }
      this.formSearch.bizId = this.organ.bizId;
      this.formSearch.bizType = this.organ.bizType;
      this.formSearch.parentId = this.organ.orgId;
      this.$getJSON(apis.deviceLocationPage, this.formSearch).then((res) => {
        this.tableList = res.data.list || [];
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getLocationPage();
    },
    // 关联项目
    onBind: function () {
      this.dialogModel.title = this.$t('base_organ_location_auto.tian_jia_xiang_mu');
      this.dialogVisible = true;
    },
    // 取消关联
    onUnbind: function () {
      const tips = this.$t('base_organ_location_auto.nqdyjxzdxmcxzdbmzyc');
      const params = this.tableSelect.map((t) => ({
        orgId: this.organ.orgId,
        bizId: this.organ.bizId,
        bizType: this.organ.bizType,
        toBizId: t.locationId,
        toBizType: 4,
      }));
      this.$showConfirm(tips)
        .then(() => {
          this.$postJSON(apis.organDeviceBindAutoDel, params).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.$emit('success');
            this.getLocationPage();
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss">
.organ-location-auto {
  .tip {
    background: rgba(254, 244, 219, 1);
    margin-bottom: 16px;
    padding-left: 10px;
    .icon {
      color: #eebf4d;
      font-size: 12px;
      margin-right: 10px;
    }
    span {
      line-height: 32px;
      color: #6c757d;
      font-size: 12px;
    }
  }
}
</style>
